export const ADDRESS_NUMBER_ERROR = 'O número do endereço deve conter apenas números e ter no máximo 6 dígitos.'

export function isAddressNumberValid (number) {
  if (number === null || number === undefined) return true
  return (typeof number === 'string' || typeof number === 'number') &&
    String(number).length <= 6 && !/[^0-9]/.test(String(number))
}
